import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-mms-analysis",
  "use": "icon-mms-analysis-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-mms-analysis\"><defs><style type=\"text/css\"></style></defs><path d=\"M622.592 545.96608a233.82016 233.82016 0 1 0-222.35136 0c-160.4608 44.6976-277.37088 182.272-277.37088 346.112a22.80448 22.80448 0 0 0 8.01792 18.33984 27.05408 27.05408 0 0 0 18.33984 8.01792h725.51424a22.80448 22.80448 0 0 0 18.33984-8.01792 27.04384 27.04384 0 0 0 8.01792-18.33984c-1.1264-163.88096-118.03648-301.4144-278.50752-346.112zM411.70944 861.184h-89.40544V701.83936a38.15424 38.15424 0 0 1 37.82656-37.82656H372.736a38.16448 38.16448 0 0 1 37.82656 37.82656V861.184z m144.384 0h-89.40544V664.0128a38.16448 38.16448 0 0 1 37.82656-37.82656H517.12a38.15424 38.15424 0 0 1 37.82656 37.82656V861.184z m145.5616 0H612.2496V701.83936a38.16448 38.16448 0 0 1 37.82656-37.82656h12.60544a38.15424 38.15424 0 0 1 37.82656 37.82656V861.184z\" p-id=\"24797\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/mms-analysis.svg
// module id = HmVO
// module chunks = 85